module.exports = __webpack_public_path__ + "static/media/balmain_runway.7da8107b.jpg";